import React from 'react'
import ComingSoon from '../../compopnents/comingSoon'

function Settings() {
  return (
   <ComingSoon />
  )
}

export default Settings